import { render } from "./Leaders.vue?vue&type=template&id=ed1db904&scoped=true"
import script from "./Leaders.vue?vue&type=script&lang=js"
export * from "./Leaders.vue?vue&type=script&lang=js"

import "./Leaders.vue?vue&type=style&index=0&id=ed1db904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1db904"]])

export default __exports__